export default __webpack_public_path__ + "ec05a8eae032c0f29e9cef3fc02f23ac.png";